// apps/pwa-pos/src/components/SesionCajaAnteriorDialog.tsx
// Sprint 99 (audit-s99 MIB-25) — extraído de SalePage.tsx para mantener
// el page <500 líneas. Bloquea la venta cuando hay una sesión de caja
// abierta de un día anterior.

import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import type { SesionCaja } from '@/lib/cash';

export function SesionCajaAnteriorDialog({
  sesion,
  onClose,
}: {
  sesion: SesionCaja;
  onClose: () => void;
}) {
  const fecha = new Date(sesion.fecha_apertura).toLocaleDateString('es-CO', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="caja-anterior-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <div className="bg-neutral-0 mx-4 w-full max-w-sm rounded-lg border border-neutral-200 p-6 shadow-xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="bg-danger-soft flex h-12 w-12 shrink-0 items-center justify-center rounded-full">
            <AlertTriangle className="text-danger h-6 w-6" aria-hidden="true" />
          </div>
          <div>
            <h2 id="caja-anterior-title" className="text-lg font-semibold text-neutral-900">
              Caja sin cerrar
            </h2>
            <p className="text-sm text-neutral-500">Acción requerida</p>
          </div>
        </div>
        <p className="mb-6 text-sm text-neutral-700">
          Tenés una caja abierta del <strong>{fecha}</strong>. Necesitás cerrarla antes de vender
          para mantener la contabilidad del turno correcta.
        </p>
        <div className="flex flex-col gap-2">
          <Button variant="danger" onClick={onClose} className="w-full">
            Cerrar caja y arqueo
          </Button>
        </div>
      </div>
    </div>
  );
}
